import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { useHistory } from 'react-router-dom';

function LoginAuto() {
  const loginToken = localStorage.getItem('login');
  const dispatch = useAppDispatch();
  const history = useHistory();

  useEffect(() => {
    if (history.location.pathname.includes('/inquiry')) {
      return;
    }

    if (isMobile) {
      if (loginToken) {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            passportNumber: loginToken,
          },
        });
      }
    }
  }, []);

  return <></>;
}

export default LoginAuto;
